<div class="modal-header" *ngIf="activeShareProcess">
	<h4 class="modal-title d-flex align-items-center" id="modal-title">
		<span>{{ activeShareProcess.name }}</span>
	</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close button"
		aria-describedby="modal-title"
		(click)="activeModal.dismiss('Cross click')"
	></button>
</div>
<div class="modal-body" *ngIf="activeShareProcess">
	<form #shareForm="ngForm">
		<!-- Active Share Section (shown when primaryShare exists) -->
		<div *ngIf="primaryShare" class="mb-4">
			<!-- Expiration info - Display mode -->
			<div *ngIf="!isEditingExpirationDate" class="mb-3">
				<div class="d-flex align-items-center justify-content-between">
					<div>
						<label class="form-label mb-0">Vanhenemispäivä</label>
						<div class="text-muted">
							{{
								primaryShare.expirationDate !== -1
									? (primaryShare.expirationDate * 1000
										| date: "d.M.yyyy HH:mm")
									: "Ei vanhene"
							}}
						</div>
					</div>
					<button
						type="button"
						class="btn btn-outline-secondary btn-sm"
						(click)="startEditingExpirationDate()"
						title="Muokkaa vanhenemispäivää"
					>
						<i class="bi bi-pencil"></i>
					</button>
				</div>
			</div>

			<!-- Expiration info - Edit mode -->
			<div *ngIf="isEditingExpirationDate" class="mb-3">
				<label class="form-label">Muokkaa vanhenemispäivää</label>

				<div class="mb-3">
					<div class="form-check">
						<input
							class="form-check-input"
							type="checkbox"
							id="editHasExpiryDate"
							[(ngModel)]="editHasExpiryDate"
							name="editHasExpiryDate"
						/>
						<label class="form-check-label" for="editHasExpiryDate">
							Aseta vanhenemispäivä
						</label>
					</div>
				</div>

				<div class="mb-3" *ngIf="editHasExpiryDate">
					<label class="form-label">Vanhenemispäivä ja -aika</label>
					<div class="row">
						<div class="col-md-7">
							<div class="input-group">
								<input
									class="form-control"
									placeholder="pp.kk.vvvv"
									name="editDp"
									[(ngModel)]="editExpirationDatePicker"
									ngbDatepicker
									#editD="ngbDatepicker"
									[displayMonths]="1"
									[firstDayOfWeek]="1"
								/>
								<button
									class="btn btn-outline-secondary bi bi-calendar3"
									(click)="editD.toggle()"
									type="button"
								></button>
							</div>
						</div>
						<div class="col-md-5">
							<div class="input-group">
								<input
									type="number"
									class="form-control"
									placeholder="HH"
									name="editExpirationHour"
									[(ngModel)]="editExpirationHour"
									min="0"
									max="23"
									style="max-width: 70px"
								/>
								<span class="input-group-text">:</span>
								<input
									type="number"
									class="form-control"
									placeholder="MM"
									name="editExpirationMinute"
									[(ngModel)]="editExpirationMinute"
									min="0"
									max="59"
									style="max-width: 70px"
								/>
								<span class="input-group-text">
									<i class="bi bi-clock"></i>
								</span>
							</div>
						</div>
					</div>
				</div>

				<div class="d-flex gap-2">
					<button
						type="button"
						class="btn btn-primary btn-sm"
						(click)="saveExpirationDate()"
						[disabled]="shareBeingUpdated !== null"
					>
						<span
							*ngIf="shareBeingUpdated !== null"
							class="spinner-border spinner-border-sm me-1"
							role="status"
							aria-hidden="true"
						></span>
						Tallenna
					</button>
					<button
						type="button"
						class="btn btn-secondary btn-sm"
						(click)="cancelEditingExpirationDate()"
						[disabled]="shareBeingUpdated !== null"
					>
						Sulje
					</button>
				</div>
			</div>

			<!-- Share Link -->
			<div class="mb-3">
				<label class="form-label">Julkaisulinkki</label>
				<div class="input-group">
					<input
						type="text"
						class="form-control"
						[value]="GetShareURL(primaryShare.uuid)"
						readonly
					/>
					<button
						class="btn btn-outline-secondary"
						(click)="
							copySharedLinkToClipboardFromModal(primaryShare)
						"
						title="Kopioi linkki"
					>
						<i class="bi bi-clipboard"></i>
					</button>
				</div>
			</div>

			<!-- Embed Code -->
			<div class="mb-3">
				<label class="form-label">Upotuskoodi</label>
				<div class="input-group">
					<textarea
						class="form-control"
						rows="3"
						[value]="GetShareIFrameCode(primaryShare.uuid)"
						readonly
					></textarea>
					<button
						class="btn btn-outline-secondary align-self-start"
						(click)="
							copyEmbedCodeToClipboardFromModal(primaryShare)
						"
						title="Kopioi upotuskoodi"
					>
						<i class="bi bi-clipboard"></i>
					</button>
				</div>
			</div>

		</div>

		<!-- Create New Share Section (shown when NO primaryShare exists) -->
		<div *ngIf="!primaryShare && !activeShareProcess.isShared">
			<div class="mb-3">
				<label for="shareName" class="form-label">Julkaisun nimi</label>
				<input
					type="text"
					id="shareName"
					class="form-control"
					[(ngModel)]="activeShareProcess.name"
					name="shareName"
					[disabled]="activeShareProcess.isSharing"
				/>
			</div>
		</div>

		<div *ngIf="!primaryShare && !activeShareProcess.isShared">
			<div class="mb-3">
				<div class="form-check">
					<input
						class="form-check-input"
						type="checkbox"
						id="hasExpiryDate"
						[(ngModel)]="hasExpiryDate"
						(ngModelChange)="onExpiryDateCheckboxChange()"
						name="hasExpiryDate"
						[disabled]="activeShareProcess.isSharing"
					/>
					<label class="form-check-label" for="hasExpiryDate">
						Aseta vanhenemispäivä
					</label>
				</div>
			</div>

			<div class="mb-3" *ngIf="hasExpiryDate">
				<label for="expirationDate" class="form-label"
					>Julkaisun vanhenemispäivä ja -aika</label
				>
				<div class="row">
					<div class="col-md-7">
						<div class="input-group">
							<input
								class="form-control"
								placeholder="pp.kk.vvvv"
								name="dp"
								[(ngModel)]="expirationDatePicker"
								(ngModelChange)="updateExpirationDateTime()"
								ngbDatepicker
								#d="ngbDatepicker"
								[disabled]="activeShareProcess.isSharing"
								[displayMonths]="1"
								[firstDayOfWeek]="1"
							/>
							<button
								class="btn btn-outline-secondary bi bi-calendar3"
								(click)="d.toggle()"
								type="button"
								[disabled]="activeShareProcess.isSharing"
							></button>
						</div>
					</div>
					<div class="col-md-5">
						<div class="input-group">
							<input
								type="number"
								class="form-control"
								placeholder="HH"
								name="expirationHour"
								[(ngModel)]="expirationHour"
								(ngModelChange)="updateExpirationDateTime()"
								min="0"
								max="23"
								[disabled]="activeShareProcess.isSharing"
								style="max-width: 70px"
							/>
							<span class="input-group-text">:</span>
							<input
								type="number"
								class="form-control"
								placeholder="MM"
								name="expirationMinute"
								[(ngModel)]="expirationMinute"
								(ngModelChange)="updateExpirationDateTime()"
								min="0"
								max="59"
								[disabled]="activeShareProcess.isSharing"
								style="max-width: 70px"
							/>
							<span class="input-group-text">
								<i class="bi bi-clock"></i>
							</span>
						</div>
					</div>
				</div>
				<small class="text-muted"
					>Valitse päivämäärä ja kellonaika</small
				>
			</div>

			<p class="mt-3">Sisältö on tämän jälkeen nähtävillä julkisesti.</p>
		</div>

		<div
			*ngIf="activeShareProcess.isSharing && !activeShareProcess.isShared"
			class="d-flex justify-content-center my-3"
		>
			<div class="spinner-border" role="status">
				<span class="visually-hidden">Ladataan...</span>
			</div>
		</div>

		<!-- Legacy Shares Section (older shares when multiple exist) -->
		<div *ngIf="legacyShares.length > 0" class="mt-4">
			<h5 class="text-muted mb-3">
				<i class="bi bi-archive me-2"></i>Vanhat julkaisut
				<span class="badge bg-secondary ms-2">{{
					legacyShares.length
				}}</span>
			</h5>

			<div class="alert alert-info mb-3">
				<i class="bi bi-info-circle me-2"></i>
				Nämä ovat vanhempia julkaisuja. Suosittelemme käyttämään yllä
				olevaa aktiivista julkaisua.
			</div>

			<div class="w-100">
				<table class="table table-striped table-sm">
					<thead>
						<tr>
							<th scope="col">Nimi</th>
							<th scope="col">Vanhentuu</th>
							<th scope="col">Luotu</th>
							<th scope="col"></th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="let share of legacyShares"
							[ngClass]="{
								'table-secondary': isShareExpired(share),
							}"
							[style.cursor]="
								sharesBeingLoadedInModal.has(share.id)
									? 'wait'
									: 'pointer'
							"
							(click)="
								!sharesBeingLoadedInModal.has(share.id) &&
									playShareFromModal(share)
							"
						>
							<td>
								<div class="d-flex align-items-center">
									<span
										*ngIf="
											sharesBeingLoadedInModal.has(
												share.id
											)
										"
										class="spinner-border spinner-border-sm text-primary me-2"
										role="status"
										aria-hidden="true"
									></span>
									<i
										*ngIf="
											!sharesBeingLoadedInModal.has(
												share.id
											)
										"
										class="bi bi-play-fill play-icon me-2"
									></i>
									<i
										class="bi bi-clock-history text-muted me-2"
										*ngIf="isShareExpired(share)"
										title="Vanhentunut"
									></i>
									<span
										[ngClass]="{
											'text-muted': isShareExpired(share),
										}"
									>
										{{
											share.name ||
												activeShareProcess.exportData
													.name
										}}
									</span>
								</div>
							</td>
							<td>
								<small
									[ngClass]="{
										'text-muted': isShareExpired(share),
									}"
								>
									{{
										share.expirationDate &&
										share.expirationDate !== -1
											? (share.expirationDate * 1000
												| date: "d.M.yyyy HH:mm")
											: "Ei vanhene"
									}}
								</small>
							</td>
							<td>
								<small
									[ngClass]="{
										'text-muted': isShareExpired(share),
									}"
								>
									{{
										share.creationDate &&
										share.creationDate !== -1
											? (share.creationDate * 1000
												| date: "d.M.yyyy HH:mm")
											: "Ei tiedossa"
									}}
								</small>
							</td>
							<td (click)="$event.stopPropagation()">
								<div class="btn-group">
									<button
										type="button"
										class="btn btn-outline-secondary btn-sm"
										(click)="previewShareFromModal(share)"
										title="Esikatsele (uusi ikkuna)"
										[disabled]="
											sharesBeingDeletedInModal.has(
												share.id
											)
										"
									>
										<i class="bi bi-box-arrow-up-right"></i>
									</button>
									<button
										type="button"
										class="btn btn-outline-secondary btn-sm"
										(click)="
											copySharedLinkToClipboardFromModal(
												share
											)
										"
										title="Kopioi linkki"
										[disabled]="
											sharesBeingDeletedInModal.has(
												share.id
											)
										"
									>
										<i class="bi bi-link-45deg"></i>
									</button>
									<button
										type="button"
										class="btn btn-outline-secondary btn-sm"
										(click)="
											copyEmbedCodeToClipboardFromModal(
												share
											)
										"
										title="Kopioi upotuskoodi"
										[disabled]="
											sharesBeingDeletedInModal.has(
												share.id
											)
										"
									>
										<i class="bi bi-code-slash"></i>
									</button>
									<button
										type="button"
										class="btn btn-outline-danger btn-sm"
										(click)="deleteShareFromModal(share)"
										title="Poista julkaisu"
										[disabled]="
											sharesBeingDeletedInModal.has(
												share.id
											)
										"
									>
										<i
											class="bi bi-trash3"
											*ngIf="
												!sharesBeingDeletedInModal.has(
													share.id
												)
											"
										></i>

										<div
											class="spinner-border spinner-border-sm text-danger ms-2"
											*ngIf="
												sharesBeingDeletedInModal.has(
													share.id
												)
											"
											role="status"
										>
											<span class="visually-hidden"
												>Poistetaan...</span
											>
										</div>
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- Existing Shares Section (only shown when NOT using primary/legacy pattern) -->
		<div
			class="mt-4"
			*ngIf="
				currentExportShares.length > 0 &&
				!primaryShare &&
				legacyShares.length === 0
			"
		>
			<h5 class="text-muted mb-3">
				<i class="bi bi-globe me-2"></i>Olemassa olevat julkaisut
				<span class="badge bg-info text-white ms-2">{{
					currentExportShares.length
				}}</span>
			</h5>

			<div class="w-100">
				<table class="table table-striped table-sm">
					<thead>
						<tr>
							<th
								scope="col"
								class="sortable-header"
								(click)="sortModalShares('name')"
							>
								Nimi
								<i
									class="ms-1"
									[ngClass]="getSharesSortIcon('name')"
								></i>
							</th>
							<th
								scope="col"
								class="sortable-header"
								(click)="sortModalShares('expirationDate')"
							>
								Vanhentuu
								<i
									class="ms-1"
									[ngClass]="
										getSharesSortIcon('expirationDate')
									"
								></i>
							</th>
							<th
								scope="col"
								class="sortable-header"
								(click)="sortModalShares('creationDate')"
							>
								Luotu
								<i
									class="ms-1"
									[ngClass]="
										getSharesSortIcon('creationDate')
									"
								></i>
							</th>
							<th scope="col"></th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="let share of filteredCurrentExportShares"
							[ngClass]="{
								'table-secondary': isShareExpired(share),
							}"
							[style.cursor]="
								sharesBeingLoadedInModal.has(share.id)
									? 'wait'
									: 'pointer'
							"
							(click)="
								!sharesBeingLoadedInModal.has(share.id) &&
									playShareFromModal(share)
							"
						>
							<td>
								<div class="d-flex align-items-center">
									<span
										*ngIf="
											sharesBeingLoadedInModal.has(
												share.id
											)
										"
										class="spinner-border spinner-border-sm text-primary me-2"
										role="status"
										aria-hidden="true"
									></span>
									<i
										*ngIf="
											!sharesBeingLoadedInModal.has(
												share.id
											)
										"
										class="bi bi-play-fill play-icon me-2"
									></i>
									<i
										class="bi bi-clock-history text-muted me-2"
										*ngIf="isShareExpired(share)"
										title="Vanhentunut"
									></i>
									<span
										[ngClass]="{
											'text-muted': isShareExpired(share),
										}"
									>
										{{
											share.name ||
												activeShareProcess.exportData
													.name
										}}
									</span>
								</div>
							</td>
							<td>
								<small
									[ngClass]="{
										'text-muted': isShareExpired(share),
									}"
								>
									{{
										share.expirationDate &&
										share.expirationDate !== -1
											? (share.expirationDate * 1000
												| date: "d.M.yyyy HH:mm")
											: "Ei vanhene"
									}}
								</small>
							</td>
							<td>
								<small
									[ngClass]="{
										'text-muted': isShareExpired(share),
									}"
								>
									{{
										share.creationDate &&
										share.creationDate !== -1
											? (share.creationDate * 1000
												| date: "d.M.yyyy HH:mm")
											: "Ei tiedossa"
									}}
								</small>
							</td>
							<td (click)="$event.stopPropagation()">
								<div class="btn-group">
									<button
										type="button"
										class="btn btn-outline-secondary btn-sm"
										(click)="previewShareFromModal(share)"
										title="Esikatsele (uusi ikkuna)"
										[disabled]="
											sharesBeingDeletedInModal.has(
												share.id
											)
										"
									>
										<i class="bi bi-box-arrow-up-right"></i>
									</button>
									<button
										type="button"
										class="btn btn-outline-secondary btn-sm"
										(click)="
											copySharedLinkToClipboardFromModal(
												share
											)
										"
										title="Kopioi linkki"
										[disabled]="
											sharesBeingDeletedInModal.has(
												share.id
											)
										"
									>
										<i class="bi bi-link-45deg"></i>
									</button>
									<button
										type="button"
										class="btn btn-outline-secondary btn-sm"
										(click)="
											copyEmbedCodeToClipboardFromModal(
												share
											)
										"
										title="Kopioi upotuskoodi"
										[disabled]="
											sharesBeingDeletedInModal.has(
												share.id
											)
										"
									>
										<i class="bi bi-code-slash"></i>
									</button>
									<button
										type="button"
										class="btn btn-outline-danger btn-sm"
										(click)="deleteShareFromModal(share)"
										title="Poista julkaisu"
										[disabled]="
											sharesBeingDeletedInModal.has(
												share.id
											)
										"
									>
										<i
											class="bi bi-trash3"
											*ngIf="
												!sharesBeingDeletedInModal.has(
													share.id
												)
											"
										></i>

										<div
											class="spinner-border spinner-border-sm text-danger ms-2"
											*ngIf="
												sharesBeingDeletedInModal.has(
													share.id
												)
											"
											role="status"
										>
											<span class="visually-hidden"
												>Poistetaan...</span
											>
										</div>
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div
			*ngIf="activeShareProcess.isError"
			class="alert alert-danger mt-3"
			role="alert"
		>
			<h4 class="alert-heading">Virhe sisältöä julkaistaessa.</h4>
			<p>{{ activeShareProcess.error }}</p>
			<hr />
		</div>
	</form>
</div>
<div class="modal-footer" *ngIf="activeShareProcess">
	<button
		type="button"
		class="btn btn-outline-secondary"
		(click)="activeModal.dismiss('Cancel click')"
		[disabled]="activeShareProcess.isSharing"
	>
		Peruuta
	</button>
	<button
		*ngIf="primaryShare"
		type="button"
		class="btn btn-danger"
		(click)="deleteShareFromModal(primaryShare)"
		[disabled]="sharesBeingDeletedInModal.has(primaryShare.id)"
	>
		<span
			*ngIf="sharesBeingDeletedInModal.has(primaryShare.id)"
			class="spinner-border spinner-border-sm me-1"
		></span>
		<i
			*ngIf="!sharesBeingDeletedInModal.has(primaryShare.id)"
			class="bi bi-trash3 me-1"
		></i>
		Poista julkaisu
	</button>
	<button
		*ngIf="!primaryShare"
		type="button"
		class="btn btn-primary"
		(click)="shareExperience()"
		[disabled]="activeShareProcess.isSharing"
	>
		<span
			*ngIf="activeShareProcess.isSharing"
			class="spinner-border spinner-border-sm me-1"
			role="status"
			aria-hidden="true"
		></span>
		Julkaise
	</button>
</div>
